import { useRef, useState } from "react"
import { Controller, useForm } from "react-hook-form"
import { Card, CircularProgress, Grid, Icon } from "@mui/material"
import MDBox from "components/MDBox"
import MDButton from "components/MDButton"
import MDTypography from "components/MDTypography"
import MDInput from "components/MDInput"
import DashboardLayout from "examples/LayoutContainers/DashboardLayout"
import DashboardNavbar from "examples/Navbars/DashboardNavbar"
import PackageItem from "layouts/calculate-revenue/PackageItem"
import translate from "utils/translate"

// Service
import * as packageService from "services/packages/package.service"
import MDSnackbar from "components/MDSnackbar"

function PayedPackage() {
  const [snackbarObject, setSnackbarObject] = useState({
    open: false,
    title: "",
    content: "",
    color: "primary",
    icon: "",
  })
  const [isLoading, setIsLoading] = useState(false)
  const { control, handleSubmit, reset } = useForm()
  const fileInputRef = useRef(null)
  // Handle open snackbar
  const handleOpenSnackbar = (status, title, content, icon) => {
    setSnackbarObject({
      ...snackbarObject,
      title,
      open: true,
      content,
      color: status,
      icon,
    })
  }

  // Handle close snackbar
  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    setSnackbarObject({
      ...snackbarObject,
      open: false,
    })
  }

  // update total payed packages
  const updatePayedPackages = async (data) => {
    setIsLoading(true)
    try {
      const formData = new FormData()
      formData.append("file", data.file)
      const response = await packageService.payedPackages(formData)
      if (response && response.status === 200) {
        handleOpenSnackbar("success", "Colis Payé", "Les Colis Payé a été modifié avec succès", "check_circle")
      } else {
        handleOpenSnackbar("error", "Colis Payé", translate.something_wrong, "error")
      }
      reset()
      if (fileInputRef.current) {
        fileInputRef.current.value = ""
      }
      setIsLoading(false)
    } catch (error) {
      handleOpenSnackbar("error", "Colis Payé", translate.something_wrong, "error")
      setIsLoading(false)
    }
  }

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar absolute />
        <MDBox mt={8}>
          <MDBox mb={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12}>
                <Card id="calculate-package-revenue">
                  <MDBox component="form" onSubmit={handleSubmit(updatePayedPackages)} noValidate autoComplete="off">
                    <MDBox pt={2} px={2}>
                      <Controller
                        control={control}
                        name="file"
                        defaultValue={[]}
                        rules={{
                          required: {
                            value: true,
                            message: "Ajouter le fichier de paiement",
                          },
                        }}
                        render={({ field: { onChange }, fieldState: { error } }) => (
                          <MDInput
                            fullWidth
                            variant="outlined"
                            type="file"
                            id="id-barcodes"
                            label="Fichier de paiement"
                            margin="normal"
                            placeholder="Ex: 123456789, 987654321"
                            focused
                            error={Boolean(error)}
                            helperText={error && error.message}
                            onChange={(e) => onChange(e.target.files[0])}
                            inputRef={fileInputRef}
                          />
                        )}
                      />
                    </MDBox>
                    {isLoading ? (
                      <MDBox py={4} px={2} display="flex" justifyContent="center" alignItems="center">
                        <CircularProgress color="secondary" />
                      </MDBox>
                    ) : (
                      <>
                        <MDBox pt={2} pb={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
                          <MDTypography variant="h6" fontWeight="medium">
                            Ajouter le fichier de paiement des colis payé
                          </MDTypography>
                          <MDButton type="submit" variant="gradient" color="dark">
                            <Icon>assessment</Icon>
                            &nbsp;Ajouter
                          </MDButton>
                        </MDBox>
                      </>
                    )}
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
      </DashboardLayout>
      <MDSnackbar
        color={snackbarObject.color}
        icon={snackbarObject.icon}
        title={snackbarObject.title}
        content={snackbarObject.content}
        open={snackbarObject.open}
        close={handleCloseSnackbar}
        dateTime=""
      />
    </>
  )
}

export default PayedPackage
